import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import React from 'react';
import 'prop-types';
import { jsx } from '@emotion/core';
import merge from 'deepmerge';
import noop from '../../utils/noop.js';
import Label from '../Label/Label.js';
import styleObject from '../../styles/checkbox.js';
import GlyphMinus from '../../svg/GlyphMinus.js';
import GlyphCheck from '../../svg/GlyphCheck.js';
import { dlsWhite } from '../../styles/colorsDls/dlsWhite.js';
import { useThemeContext } from '../ThemeProvider/ThemeContext.js';
import ReactlyticsTracking from '../ReactlyticsTracking.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Checkbox = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      id = _ref.id,
      label = _ref.label,
      name = _ref.name,
      indeterminate = _ref.indeterminate,
      valid = _ref.valid,
      describedBy = _ref.describedBy,
      theme = _ref.theme,
      onChange = _ref.onChange,
      reactlytics = _ref.reactlytics,
      otherProps = _objectWithoutProperties(_ref, ["className", "id", "label", "name", "indeterminate", "valid", "describedBy", "theme", "onChange", "reactlytics"]);

  var themeTokens = useThemeContext();
  var otherPropsFormatted = indeterminate ? _objectSpread(_objectSpread({}, otherProps), {}, {
    'aria-checked': 'mixed'
  }) : otherProps;
  var labelStyleObject = indeterminate ? merge.all([styleObject.checkbox_label, styleObject.checkbox_input_aria_checked_mixed____label]) : styleObject.checkbox_label;
  labelStyleObject = _objectSpread(_objectSpread({}, labelStyleObject), {}, {
    '&::after': {
      content: '""'
    }
  });

  var iconStyleObject = _objectSpread(_objectSpread({}, dlsWhite), {}, {
    alignItems: 'center',
    display: 'flex',
    fontSize: '0.84375rem',
    height: '1.375rem',
    justifyContent: 'center',
    left: '0',
    marginLeft: '-1.375rem',
    position: 'absolute',
    top: '0',
    width: '1.375rem',
    visibility: 'hidden'
  });

  var iconComponent = indeterminate ? jsx(GlyphMinus, {
    theme: iconStyleObject
  }) : jsx(GlyphCheck, {
    theme: iconStyleObject
  });
  var inputStyleObject = merge.all([styleObject.checkbox_label_input, styleObject.checkbox_input_type_checkbox, {
    '&:checked + label': {
      span: {
        visibility: 'visible'
      }
    }
  }, themeTokens.primaryColor ? {
    '&:hover + label::before': {
      borderColor: themeTokens.primaryColor
    },
    '&:checked + label:hover::before': {
      borderColor: themeTokens.primaryColor
    },
    '&:checked + label::before': {
      backgroundColor: themeTokens.primaryColor,
      borderColor: themeTokens.primaryColor
    }
  } : {}]);

  var containerStyleObject = _objectSpread(_objectSpread({}, styleObject.checkbox), {}, {
    'ul &': styleObject.checkboxGroup_ul__checkbox
  });

  if (!valid) {
    otherPropsFormatted = _objectSpread(_objectSpread({}, otherPropsFormatted), {}, {
      'aria-invalid': true
    });
    labelStyleObject = _objectSpread(_objectSpread({}, merge(labelStyleObject, styleObject.checkbox_input_aria_invalid_true____label)), {}, {
      a: styleObject.checkbox_input_aria_invalid_true____label_a
    });
    inputStyleObject = merge.all([inputStyleObject, styleObject.checkbox_input_aria_invalid_true, themeTokens.primaryColor ? {
      '&:checked + label a': {
        color: themeTokens.primaryColor
      }
    } : {}]);
  }

  return jsx("div", {
    css: _objectSpread(_objectSpread({}, containerStyleObject), theme),
    className: className
  }, jsx(ReactlyticsTracking, {
    onChange: onChange,
    reactlytics: reactlytics
  }, jsx("input", _extends({
    id: id,
    type: "checkbox",
    name: name || id,
    "aria-describedby": describedBy,
    css: inputStyleObject
  }, otherPropsFormatted, {
    ref: ref
  }))), jsx(Label, {
    css: labelStyleObject,
    htmlFor: id
  }, label, iconComponent));
});
Checkbox.displayName = 'Checkbox';
Checkbox.defaultProps = {
  className: '',
  checked: undefined,
  defaultChecked: undefined,
  onChange: noop,
  value: '',
  name: '',
  disabled: false,
  indeterminate: false,
  valid: true,
  describedBy: undefined,
  theme: undefined
};

export default Checkbox;
